var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.5H3.75C1.67893 0.5 0 2.3888 0 4.71875V14.2812C0 16.6112 1.67893 18.5 3.75 18.5H12.25C14.3211 18.5 16 16.6112 16 14.2812V4.71875C16 2.3888 14.3211 0.5 12.25 0.5Z",
    fill: "url(#paint0_radial_34_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.5H3.75C1.67893 0.5 0 2.3888 0 4.71875V14.2812C0 16.6112 1.67893 18.5 3.75 18.5H12.25C14.3211 18.5 16 16.6112 16 14.2812V4.71875C16 2.3888 14.3211 0.5 12.25 0.5Z",
    fill: "url(#paint1_radial_34_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00056 2.46875C6.30319 2.46875 6.09013 2.47712 5.4235 2.51122C4.75813 2.54553 4.30394 2.66401 3.90656 2.83789C3.49544 3.01747 3.14675 3.25773 2.79938 3.64866C2.45169 4.03953 2.23813 4.4318 2.078 4.89411C1.923 5.3413 1.81756 5.85247 1.78762 6.60066C1.75781 7.35069 1.75 7.59045 1.75 9.50007C1.75 11.4097 1.7575 11.6486 1.78775 12.3986C1.81838 13.1471 1.92369 13.6581 2.07812 14.1051C2.23787 14.5676 2.45144 14.9599 2.79894 15.3507C3.14625 15.7419 3.49494 15.9827 3.90575 16.1622C4.30344 16.3361 4.75769 16.4546 5.42294 16.4889C6.08962 16.523 6.3025 16.5314 7.99981 16.5314C9.69738 16.5314 9.90975 16.523 10.5764 16.4889C11.2417 16.4546 11.6964 16.3361 12.0941 16.1622C12.5051 15.9827 12.8532 15.7419 13.2005 15.3507C13.5482 14.9599 13.7617 14.5676 13.9219 14.1053C14.0755 13.6581 14.181 13.147 14.2122 12.3987C14.2422 11.6488 14.25 11.4097 14.25 9.50007C14.25 7.59045 14.2422 7.35083 14.2122 6.6008C14.181 5.85226 14.0755 5.34137 13.9219 4.89432C13.7617 4.4318 13.5482 4.03953 13.2005 3.64866C12.8529 3.25759 12.5052 3.01733 12.0938 2.83796C11.6953 2.66401 11.2409 2.54546 10.5755 2.51122C9.90881 2.47712 9.69656 2.46875 7.99862 2.46875H8.00056ZM7.43988 3.73585C7.60631 3.73557 7.792 3.73585 8.00056 3.73585C9.66938 3.73585 9.86712 3.7426 10.5261 3.77628C11.1355 3.80764 11.4663 3.92218 11.6866 4.01844C11.9783 4.14584 12.1862 4.29821 12.4048 4.54437C12.6236 4.79047 12.7589 5.02482 12.8725 5.35297C12.9581 5.60047 13.06 5.97256 13.0878 6.65811C13.1177 7.39934 13.1242 7.62195 13.1242 9.49845C13.1242 11.375 13.1177 11.5976 13.0878 12.3388C13.0599 13.0243 12.9581 13.3964 12.8725 13.644C12.7593 13.9722 12.6236 14.2058 12.4048 14.4518C12.1861 14.6979 11.9784 14.8501 11.6866 14.9776C11.4665 15.0743 11.1355 15.1886 10.5261 15.2199C9.86725 15.2536 9.66938 15.2609 8.00056 15.2609C6.33169 15.2609 6.13387 15.2536 5.47506 15.2199C4.86569 15.1883 4.53494 15.0737 4.31444 14.9775C4.02281 14.85 3.81444 14.6977 3.59569 14.4516C3.37694 14.2055 3.24156 13.9717 3.128 13.6434C3.04244 13.3959 2.9405 13.0238 2.91275 12.3382C2.88281 11.597 2.87681 11.3744 2.87681 9.4967C2.87681 7.61907 2.88281 7.39759 2.91275 6.65635C2.94062 5.9708 3.04244 5.59871 3.128 5.35086C3.24131 5.02271 3.37694 4.78836 3.59575 4.54227C3.8145 4.29617 4.02281 4.1438 4.3145 4.01612C4.53481 3.91944 4.86569 3.80518 5.47506 3.77368C6.05162 3.74436 6.27506 3.73557 7.43988 3.73409V3.73585ZM11.3368 4.90332C10.9228 4.90332 10.5868 5.2809 10.5868 5.74679C10.5868 6.21261 10.9228 6.59054 11.3368 6.59054C11.7509 6.59054 12.0868 6.21261 12.0868 5.74679C12.0868 5.28097 11.7509 4.90304 11.3368 4.90304V4.90332ZM8.00056 5.88917C6.22806 5.88917 4.79094 7.50594 4.79094 9.50007C4.79094 11.4942 6.22806 13.1102 8.00056 13.1102C9.77312 13.1102 11.2098 11.4942 11.2098 9.50007C11.2098 7.50601 9.773 5.88917 8.00044 5.88917H8.00056ZM8.00056 7.15627C9.15112 7.15627 10.0839 8.20555 10.0839 9.50007C10.0839 10.7945 9.15112 11.8439 8.00056 11.8439C6.84994 11.8439 5.91725 10.7945 5.91725 9.50007C5.91725 8.20555 6.84994 7.15627 8.00056 7.15627Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_34_27",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.25 19.8864) rotate(-90) scale(17.8393 14.7484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_34_27",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.68006 1.79663) rotate(79.9113) scale(7.94198 29.3368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.150e8644c388f91d62b8119f08f79eaa.svg";
export { ForwardRef as ReactComponent };